import { TouchableOpacity } from 'react-native';
import { Text, IconButton, Menu, Checkbox } from 'react-native-paper';
import { useAppTheme } from '../theme';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { toggleFilterMenu, setFilterOptions } from '../redux/businessListSlice';

export default function FilterButton() {
  const theme = useAppTheme();
  const { filterOptions, showFilterMenu } = useAppSelector(
    (state) => state.businessList
  );
  const dispatch = useAppDispatch();

  const options: ('New' | 'Active' | 'Closed')[] = ['New', 'Closed', 'Active'];

  return (
    <Menu
      visible={showFilterMenu}
      onDismiss={() => dispatch(toggleFilterMenu())}
      anchor={
        <IconButton
          icon="filter-outline"
          iconColor={theme.colors.onBackground}
          mode="contained"
          containerColor={theme.colors.background}
          accessibilityLabel="filter"
          style={{
            borderRadius: 4,
            borderWidth: 1,
            borderColor: theme.colors.backgroundBorder,
            height: 40,
          }}
          onPress={() => dispatch(toggleFilterMenu())}
        />
      }
    >
      <Text style={{ fontSize: 16, paddingLeft: 10 }}>Filter by:</Text>
      {options.map((option) => {
        return (
          <TouchableOpacity
            key={option}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginVertical: 4,
            }}
            onPress={() => dispatch(setFilterOptions(option))}
          >
            <Checkbox.Android
              status={filterOptions.includes(option) ? 'checked' : 'unchecked'}
              onPress={() => dispatch(setFilterOptions(option))}
              color="#3988BD"
            />
            <Text variant="bodyLarge" style={{ marginRight: 8 }}>
              {option}
            </Text>
          </TouchableOpacity>
        );
      })}
    </Menu>
  );
}
